import { useMutation, useQueryClient } from "@tanstack/react-query";
import { sincronizeazaTargetareActivitate } from "@/api/endpoints/targetareTinte";
import { queryKeys } from "@/lib/queryClient";

export function useSincronizeazaTargetareActivitate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: sincronizeazaTargetareActivitate,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.targetare.all });
    },
  });
}
